import { render, staticRenderFns } from "./Messagecom.vue?vue&type=template&id=53768820&scoped=true"
import script from "./Messagecom.vue?vue&type=script&lang=js"
export * from "./Messagecom.vue?vue&type=script&lang=js"
import style0 from "./Messagecom.vue?vue&type=style&index=0&id=53768820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53768820",
  null
  
)

export default component.exports